import React from 'react'
// import '@fullcalendar/core/vdom'
import FullCalendar from '@fullcalendar/react'
import type { DatesSetArg, EventContentArg } from '@fullcalendar/core'

import listPlugin from '@fullcalendar/list'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import multiMonthPlugin from '@fullcalendar/multimonth'

import { useContext } from './Context'
import { CalendarEventCheckbox } from './CalendarEventCheckbox'
import { Icon, Link, ShowIf, Switch, TooltipPopOver } from '@ztechapps/webui.util'

export const CalendarComponent = () => {
  const { displayEvents, timeZone, eventContent, setCalendarDate, showFilter, components, ...rest } = useContext()

  const datesRender = ({ view }: DatesSetArg) => {
    setCalendarDate({ currentStart: view?.currentStart, currentEnd: view?.currentEnd })
  }

  const renderEventContent = (eventInfo: EventContentArg) => {
    return (
      <TooltipPopOver tooltipBody={eventInfo.event?.extendedProps?.tooltip}>
        <Link href={eventInfo.event?.extendedProps?.url}>
          <Switch expression={!!eventInfo.event?.extendedProps?.renderEventContent}>
            {{
              true: eventInfo.event?.extendedProps?.renderEventContent,
              false: (
                <>
                  <Icon name={eventInfo.event?.extendedProps?.icon ?? 'circle'} />
                  {eventInfo.event?.title}
                </>
              ),
            }}
          </Switch>
        </Link>
      </TooltipPopOver>
    )
  }

  return (
    <React.Fragment>
      <components.topBar />
      <ShowIf condition={showFilter}>
        <div style={{ minHeight: '45px' }}>
          <div className={'d-flex justify-content-start'}>
            <CalendarEventCheckbox />
          </div>
        </div>
      </ShowIf>
      <FullCalendar
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,listMonth',
        }}
        plugins={[listPlugin, dayGridPlugin, timeGridPlugin, interactionPlugin, momentTimezonePlugin, multiMonthPlugin]}
        events={displayEvents as any}
        timeZone={timeZone}
        datesSet={datesRender}
        eventDisplay={'auto'}
        defaultAllDay={true}
        height={'75vh'}
        eventContent={eventContent ?? renderEventContent}
        {...rest}
      />
    </React.Fragment>
  )
}
